import { difference } from 'lodash'
import { getQuestionnaireUserResults, getQuestionnaireUserValuers } from '@/views/values/api'

const getDefaultState = () => {
    return {
        results: [],
        evaluated: null,
        questionnaires: [],
        questionnaireSelectIsReady: false,
    }
}

const getDefaultQuestionnaireResultsState = () => {
    return {
        isLoading: false,
        results: [],
        valuers: [],
        generalComments: [],
        hasSubjectGraphic: false,
        hasQuestionGraphic: false,
    }
}

export default {
    namespaced: true,
    state: getDefaultState(),
    getters: {
        questionnairesIds: (state) => {
            return state.questionnaires.map((q) => q.value)
        },
    },
    mutations: {
        RESET_STATE(state) {
            Object.assign(state, getDefaultState())
        },
        SET_QUESTIONNAIRES(state, newQuestionnaires) {
            state.questionnaires = newQuestionnaires
        },
        SET_QUESTIONNAIRES_IS_READY(state, value) {
            state.questionnaireSelectIsReady = value
        },
        SET_EVALUATED(state, value) {
            state.evaluated = value
        },
        ADD_QUESTIONNAIRE_RESULTS(state, result) {
            state.results.push(result)
        },
        REMOVE_QUESTIONNAIRE_RESULTS(state, questionnaireId) {
            state.results = state.results.filter((result) => {
                return result.id != questionnaireId
            })
        },
        EDIT_QUESTIONNAIRE_RESULTS(
            state,
            {
                questionnaireResults,
                id = questionnaireResults.id,
                title = questionnaireResults.title,
                valuers = questionnaireResults.valuers,
                results = questionnaireResults.results,
                isLoading = questionnaireResults.isLoading,
                generalComments = questionnaireResults.generalComments,
                hasSubjectGraphic = questionnaireResults.hasSubjectGraphic,
                hasQuestionGraphic = questionnaireResults.hasQuestionGraphic,
            }
        ) {
            state.results.map((result) => {
                if (result.id == id) {
                    result.title = title
                    result.valuers = valuers
                    result.results = results
                    result.isLoading = isLoading
                    result.generalComments = generalComments
                    result.hasSubjectGraphic = hasSubjectGraphic
                    result.hasQuestionGraphic = hasQuestionGraphic
                }
            })
        },
    },
    actions: {
        resetState({ commit }) {
            commit('RESET_STATE')
        },
        updateEvaluated({ commit }, evaluated) {
            commit('SET_EVALUATED', evaluated)
        },
        updateQuestionnaireSelectIsReady({ commit }, value) {
            commit('SET_QUESTIONNAIRES_IS_READY', value)
        },
        updateQuestionnaires({ commit, state }, newQuestionnaires) {
            if (newQuestionnaires.length > state.questionnaires.length) {
                const addeds = difference(newQuestionnaires, state.questionnaires)
                addeds.forEach((added) =>
                    commit('ADD_QUESTIONNAIRE_RESULTS', {
                        id: added.value,
                        title: added.label,
                        ...getDefaultQuestionnaireResultsState(),
                    })
                )
            } else {
                const removeds = difference(state.questionnaires, newQuestionnaires)
                removeds.forEach((removed) => commit('REMOVE_QUESTIONNAIRE_RESULTS', removed.value))
            }

            commit('SET_QUESTIONNAIRES', newQuestionnaires)
        },
        async getQuestionnaireResultsData({ commit, state }, questionnaireResults) {
            commit('EDIT_QUESTIONNAIRE_RESULTS', {
                questionnaireResults,
                isLoading: true,
            })

            const data = await getQuestionnaireUserResults(state.evaluated.id, questionnaireResults.id)

            const valuers = await getQuestionnaireUserValuers(
                state.evaluated.id,
                questionnaireResults.id,
                data.published_networks
            )

            const { general_comments, results, subject_graphic_is_published, question_graphic_is_published } = data

            commit('EDIT_QUESTIONNAIRE_RESULTS', {
                questionnaireResults,
                results,
                valuers,
                hasSubjectGraphic: subject_graphic_is_published,
                hasQuestionGraphic: question_graphic_is_published,
                isLoading: false,
                generalComments: general_comments,
            })
        },
    },
}
